import { nanoid } from 'nanoid';
import React from 'react';

const VipIcon = ({ style }: { style?: React.CSSProperties }) => {
    const id = nanoid();
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" style={style}>
            <circle cx="7" cy="7" r="7" fill={`url(#${id})`} />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.65786 3.78305L11.2915 5.52984C11.5695 5.83714 11.5695 6.29002 11.2915 6.58924L7.6593 10.471C7.31173 10.843 6.69479 10.843 6.34721 10.471L2.71506 6.58115C2.42831 6.28193 2.42831 5.82906 2.71506 5.52175L4.34866 3.77496C4.51376 3.60513 4.75706 3.5 5.00905 3.5H8.99747C9.24946 3.5 9.48407 3.60513 9.65786 3.78305ZM8.1807 7.01846L9.04964 6.48472C9.24949 6.36342 9.30163 6.11272 9.17129 5.92672C9.04095 5.74072 8.77157 5.68411 8.58041 5.8135L7.71147 6.34724C7.25963 6.6222 6.68613 6.6222 6.24297 6.33107L5.45224 5.8135C5.25239 5.68411 4.98302 5.72454 4.84399 5.91054C4.70496 6.09655 4.7484 6.34724 4.94826 6.47663L5.73899 6.9942C6.11263 7.23681 6.5471 7.35812 6.98157 7.35812C7.39866 7.35812 7.81575 7.2449 8.1807 7.01846Z"
                fill="#5C260B"
            />
            <defs>
                <linearGradient
                    id={id}
                    x1="14"
                    y1="14"
                    x2="-1.76343e-06"
                    y2="1.76343e-06"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FFC39E" />
                    <stop offset="0.503906" stopColor="#FFBD97" />
                    <stop offset="0.511719" stopColor="#FFC9AA" />
                    <stop offset="1" stopColor="#FFD6BF" />
                </linearGradient>
            </defs>
        </svg>
    );
};

VipIcon.displayName = 'VipIcon';

export default VipIcon;
